/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { LeavePeriod } from './LeavePeriod';
import {
    LeavePeriodFromJSON,
    LeavePeriodFromJSONTyped,
    LeavePeriodToJSON,
    LeavePeriodToJSONTyped,
} from './LeavePeriod';

/**
 * 
 * @export
 * @interface ListLeavePeriodsResponse
 */
export interface ListLeavePeriodsResponse {
    /**
     * 
     * @type {Array<LeavePeriod>}
     * @memberof ListLeavePeriodsResponse
     */
    data: Array<LeavePeriod>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListLeavePeriodsResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListLeavePeriodsResponse interface.
 */
export function instanceOfListLeavePeriodsResponse(value: object): value is ListLeavePeriodsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListLeavePeriodsResponseFromJSON(json: any): ListLeavePeriodsResponse {
    return ListLeavePeriodsResponseFromJSONTyped(json, false);
}

export function ListLeavePeriodsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListLeavePeriodsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(LeavePeriodFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListLeavePeriodsResponseToJSON(json: any): ListLeavePeriodsResponse {
      return ListLeavePeriodsResponseToJSONTyped(json, false);
  }

  export function ListLeavePeriodsResponseToJSONTyped(value?: ListLeavePeriodsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(LeavePeriodToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

